import axios from "axios";
import { useQuery } from "react-query";

import { InvoiceApprovalThreshold } from "fe-shared/src/types/common/invoice";

const DEFAULT_SETTINGS : InvoiceApprovalThreshold[] = 
[
    {
        approvalTypeCode: "InApproval",
        roleCode: "ApproveInvoiceClerkLevel",
        from: 0.00,
        to: 25000.00
    },
    {
        approvalTypeCode: "InApproval",
        roleCode: "ApproveInvoiceManagerLevel",
        from: 25000.00,
        to: 125000.00
    },
    {
        approvalTypeCode: "InApproval",
        roleCode: "ApproveInvoiceDirectorLevel",
        from: 125000.00,
        to: 500000.00
    },
    {
        approvalTypeCode: "InApproval",
        roleCode: "ApproveInvoiceExecutiveLevel",
        from: 500000.00,
        to: undefined
    },
    {
        approvalTypeCode: "InApproval",
        roleCode: "ApproveInvoiceCEOLevel",
        from: 0.00,
        to: 0.00
    },
    {
        approvalTypeCode: "Approved",
        roleCode: "ApproveInvoiceClerkLevel",
        from: 0.00,
        to: 0.00
    },
    {
        approvalTypeCode: "Approved",
        roleCode: "ApproveInvoiceManagerLevel",
        from: 0.00,
        to: 25000.00
    },
    {
        approvalTypeCode: "Approved",
        roleCode: "ApproveInvoiceDirectorLevel",
        from: 25000.00,
        to: 125000.00
    },
    {
        approvalTypeCode: "Approved",
        roleCode: "ApproveInvoiceExecutiveLevel",
        from: 125000.00,
        to: 500000.00
    },
    {
        approvalTypeCode: "Approved",
        roleCode: "ApproveInvoiceCEOLevel",
        from: 500000.00,
        to: undefined
    }
];

const getInvoiceApprovalThresholds = () => 
    axios
        .get<InvoiceApprovalThreshold[]>("financeThresholds/invoiceApproval")
        .then((response) => response.data);

const useInvoiceApprovalThresholds = () => {
    const { data } = useQuery("invoiceApprovalThresholds", getInvoiceApprovalThresholds, {
        staleTime: Infinity,
    });

    return data || DEFAULT_SETTINGS
}

export default useInvoiceApprovalThresholds;